{
    angular.module('interfaceModule')
        .controller('LoginController',LoginController);
    LoginController.$inject = ['$state',"request.login",'$scope','requestHandler',
    'md5',"utils.constant",'alertControl','utils.common',
    'utils.platform','$window','$stateParams'];
    function LoginController($state,loginRequest,$scope,requestHandler,
        md5,constant,alertControl,common,
        platform,$window,$stateParams) {
        let vm=this;
        let collect={
            'login':login,
            'forget':forget,
            'register':register,
            'checkPhone':checkPhone,
            'Verify_code':Verify_code,
            'userquery':userquery,
            'changeCompanyUser': changeCompanyUser,     //申请企业用户
            'application':application,     //申请
            'openId':'',
            'showForm':false,
            Change:Change,
            forgetChange :false,
            loginChange:true,
            registerChange:false,
            no_exist:false,
            'companyUser':false,

            agreement:true, //协议状态
            agreement_pop:false, //协议展示
            agreement_boo:agreement_boo,
            protocol:protocol,  //弹出协议框
            protocol_confirm:protocol_confirm,  //同意协议

            registerFocus:registerFocus,
        };
        let loginInfo = {
            username:'',
            password:''
        };
        let registerInfo={
            phone:'',
            Verification:'',
            password:'',
            confirm:''
        };
        let forgetInfo={
            phone:'',
            Verification:'',
            password:'',
            confirm:''
        };
        let applicationInfo={
            userid: '',
            companyid: '',
            password: '',
        };

        vm.collect=collect;
        vm.loginInfo = loginInfo;
        vm.registerInfo = registerInfo;
        vm.forgetInfo = forgetInfo;
        vm.applicationInfo = applicationInfo;

        activate();

        function activate() {
            //console.log('login',platform.isWechat());

//console.log(code);
            if(platform.isWechat()){
                // let code=GetQueryString("code");
//alert('code: '+code);
                if($stateParams.openid){
                    common.loading.show();
                    // loginRequest.getOpenId(code).then(function(resData){
                    //     collect.openId=resData.openid;
                        collect.openId=$stateParams.openid;
                        //alert('openId: '+collect.openId);
                        // if(collect.openId){//"opdMJwfe89B3y4V5eODG138gRHUA"
                            loginRequest.loginWithOpenId(collect.openId).then(function(resData){
                                common.loading.hide();
                                if(resData.result==1){
                                    $state.go('main.home');           //在这里修改了连接地址
                                    // $state.go('main.advertising');
                                }else{
                                    collect.showForm=true;
                                }
                            },function(resData){
                                common.loading.hide();
                                collect.showForm=true;
                            });
                        // }else{
                            // common.loading.hide();
                        // }
                    // },function(){
                    //     common.loading.hide();
                    // });
                }else{
                    //http%3A%2F%2Fwww.my51y.com%2Fxyprint_web1%2Finterfaces%2Fwx_openid.php

                    // let url="https://open.weixin.qq.com/connect/oauth2/authorize"
                    // +"?appid=wxd74ac0eb28871e46"
                    // +"&redirect_uri="+encodeURIComponent("http://www.my51y.com/xyprint_web1/#!/login")
                    // +"&response_type=code&scope=snsapi_base&state=TEST&connect_redirect=1#wechat_redirect";
//console.log(url);
                    // constant.config.sitePath+constant.action.wechatOpenId
                    let url=constant.config.sitePath+constant.action.wechatOpenId;
                    $window.location.href=url;

                }
                
            }else{
                collect.showForm=true;
            }

        }

        // function GetQueryString(name){
        //      var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
        //      var r = window.location.search.substr(1).match(reg);
        //      if(r!=null)
        //         return  unescape(r[2]);
        //      return null;
        // }

        function login(){
            loginInfo.username=$("#username").val();
            loginInfo.password=$("#pwd").val();
            // '111111','888888'
            loginRequest.login(loginInfo.username,encodeURIComponent(loginInfo.password),collect.openId)
                .then(function(data){
                    //console.log(data);
                        if(data[0].result==1){

                            $state.go('main.home');
                            // $state.go('main.advertising');
                        }else if(data[0].result==0){
                            if(loginInfo.username.length<=0){
                                let alert=alertControl.show('',
                                    '请输入登录账号',
                                    [{
                                        'title':'确定',
                                        'action':function(){
                                            alert.close();
                                        }
                                    }]
                                );
                            }else if(loginInfo.password.length<=0){
                                let alert=alertControl.show('',
                                    '请输入登录密码',
                                    [{
                                        'title':'确定',
                                        'action':function(){
                                            alert.close();
                                        }
                                    }]
                                );
                            }else {
                                // alert("您输入的账号或密码不正确！");
                                let alert=alertControl.show('',
                                    '您输入的账号或密码不正确！',
                                    [{
                                        'title':'确定',
                                        'action':function(){
                                            alert.close();
                                        }
                                    }]
                                );
                            }
                        }else if(data[0].result==2){
                            let alert=alertControl.show('',
                                '该账号已停用！',
                                [{
                                    'title':'确定',
                                    'action':function(){
                                        alert.close();
                                    }
                                }]
                            );
                        }else {
                            let alert=alertControl.show('',
                                '登录时出现未知错误，请与软件开发商联系1！',
                                [{
                                    'title':'确定',
                                    'action':function(){
                                        alert.close();
                                    }
                                }]
                            );
                        }
                    },
                    function (data) {
                        // console.log(1);
                        // console.log(data);
                            let alert=alertControl.show('',
                                '登录时出现未知错误，请与软件开发商联系2！',
                                [{
                                    'title':'确定',
                                    'action':function(){
                                        alert.close();
                                    }
                                }]
                            );
                        

                    }
             );
        }

        //修改密码
        function forget(userId,password,confirm,Verification,num) {

            // if (collect.no_exist){
                
            // }else {
                if (password===confirm){
                    if (Verification.length>0){
                        let Verificationparams=[{
                            'smstype':'1',
                            'userid':encodeURIComponent(userId),
                            'smscode':encodeURIComponent(Verification),
                        }];

                        let strVerification='userinfo='+JSON.stringify(Verificationparams);
                        requestHandler.simpleRequest(constant.action.getVerify_code,strVerification).then(function(msg){

                            if (msg.data.code=="200"){
                                let _data = new Date();
                                let year = _data.getFullYear(),
                                    month= _data.getMonth() + 1,
                                    data = _data.getDate(),
                                    hour = _data.getHours(),
                                    minutes = _data.getMinutes(),
                                    seconds = _data.getSeconds();
                                let pwdchangetime = year + '-' + month + '-' + data + ' ' + hour + ':' + minutes + ':' + seconds;
                                let params=[{
                                    'userid':userId,
                                    'pwd':md5.createHash(encodeURIComponent(password)),
                                    'pwdchangetime' : pwdchangetime
                                }];
                                let str='userinfo='+JSON.stringify(params);
                                requestHandler.simpleRequest(constant.action.usersset,str).then(function (respone) {
                                    if (respone.data[0].result==1){
                                        if (num==2){
                                            let alert=alertControl.show('',
                                                '注册成功',
                                                [{
                                                    'title':'确定',
                                                    'action':function(){
                                                        alert.close();
                                                    }
                                                }]
                                            );
                                        }else {
                                            let alert=alertControl.show('',
                                                '修改密码成功',
                                                [{
                                                    'title':'确定',
                                                    'action':function(){
                                                        alert.close();

                                                        collect.Change(3);
                                                    }
                                                }]
                                            );
                                        }
                                    }else {
                                        let alert=alertControl.show('',
                                            '修改失败',
                                            [{
                                                'title':'确定',
                                                'action':function(){
                                                    alert.close();
                                                }
                                            }]
                                        );
                                    }
                                });
                            }else {
                                let alert=alertControl.show('',
                                    '验证码错误',
                                    [{
                                        'title':'确定',
                                        'action':function(){
                                            alert.close();
                                        }
                                    }]
                                );
                            }
                        });
                    }else {
                        let alert=alertControl.show('',
                            '请输入验证码',
                            [{
                                'title':'确定',
                                'action':function(){
                                    alert.close();
                                }
                            }]
                        );
                    }
                }else {
                    let alert=alertControl.show('',
                        '两次输入的密码不一致',
                        [{
                            'title':'确定',
                            'action':function(){
                                alert.close();
                            }
                        }]
                    );
                }
            // }
        }

        //点击注册按钮触发
        function register() {
            // if (collect.no_exist){
                if(collect.agreement == false){
                    let alert=alertControl.show('',
                        '请勾选同意致快云印服务协议！',
                        [{
                            'title':'确定',
                            'action':function(){
                                alert.close();
                            }
                        }]
                    );
                    return;
                }
                if (registerInfo.password===registerInfo.confirm ){
                    if (registerInfo.password == null || registerInfo.password == undefined){
                        let alert=alertControl.show('',
                            '密码不能为空！',
                            [{
                                'title':'确定',
                                'action':function(){
                                    alert.close();
                                }
                            }]
                        );
                    }else{
                        if (registerInfo.Verification.length>0){
                            let params=[{
                                'smstype':'1',
                                'userid':encodeURIComponent(registerInfo.phone),
                                'smscode':encodeURIComponent(registerInfo.Verification),
                            }];

                            let str='userinfo='+JSON.stringify(params);
                            requestHandler.simpleRequest(constant.action.getVerify_code,str).then(function(msg){
                                if (msg.data.code=="200"){
                                    let params2=[{
                                        'userid':registerInfo.phone,
                                        'phone':registerInfo.phone,
                                        'pwd':md5.createHash(encodeURIComponent(registerInfo.password))
                                    }];
                                    // let params='userid='+userName+'&pwd='+password;
                                    let str='userinfo='+JSON.stringify(params2);
                                    requestHandler.simpleRequest(constant.action.registerNew,str).then(function(responce){
                                        if (responce.data[0].result == 1){
                                            let alert=alertControl.show('',
                                                '注册成功',
                                                [{
                                                    'title':'确定',
                                                    'action':function(){
                                                        alert.close();
                                                        collect.Change(3);
                                                    }
                                                }]
                                            );
                                        }else{
                                            let alert=alertControl.show('',
                                                '注册失败,请重新注册！',
                                                [{
                                                    'title':'确定',
                                                    'action':function(){
                                                        alert.close();
                                                    }
                                                }]
                                            );
                                        }


                                    },function(resData){
                                        let alert=alertControl.show('',
                                            '注册失败',
                                            [{
                                                'title':'确定',
                                                'action':function(){
                                                    alert.close();
                                                }
                                            }]
                                        );
                                    });
                                }else{
                                    let alert=alertControl.show('',
                                        '验证码错误',
                                        [{
                                            'title':'确定',
                                            'action':function(){
                                                alert.close();
                                            }
                                        }]
                                    );
                                }

                            },function(resData){
                                let alert=alertControl.show('',
                                    '验证码错误',
                                    [{
                                        'title':'确定',
                                        'action':function(){
                                            alert.close();
                                        }
                                    }]
                                );
                            });
                        }else {
                            let alert=alertControl.show('',
                                '请输入验证码',
                                [{
                                    'title':'确定',
                                    'action':function(){
                                        alert.close();
                                    }
                                }]
                            );
                        }

                    }

                }else {
                    let alert=alertControl.show('',
                        '两次输入的密码不一致',
                        [{
                            'title':'确定',
                            'action':function(){
                                alert.close();
                            }
                        }]
                    );
                }

            // }else {
            //     // forget(registerInfo.phone,registerInfo.password,registerInfo.confirm,registerInfo.Verification,2);
                
            // }
        }

        //验证验证码
        function Verify_code(userId,Verification) {
            let params=[{
                'smstype':'1',
                'userid':encodeURIComponent(userId),
                'smscode':encodeURIComponent(Verification),
            }];

            let str='userinfo='+JSON.stringify(params);
            requestHandler.simpleRequest(constant.action.getVerify_code,str).then(function(msg){
                let checkresult=msg;
                console.log(1);
                console.log(checkresult);
                if (checkresult.data.code=="200"){

                }else {
                    // alert("验证码错误");
                    let alert=alertControl.show('',
                        '验证码错误',
                        [{
                            'title':'确定',
                            'action':function(){
                                alert.close();
                            }
                        }]
                    );
                }
            });
        }


        //登录、注册、忘记密码的切换
        function Change(parameter) {
            if (parameter===1){
                collect.forgetChange=true;
                collect.registerChange=false;
                collect.loginChange=false;
                collect.companyUser = false;
            }else if (parameter===2){
                collect.forgetChange=false;
                collect.registerChange=true;
                collect.loginChange=false;
                collect.companyUser = false;
            }else if(parameter===4){
                collect.forgetChange=false;
                collect.registerChange=true;
                collect.loginChange=false;
                collect.companyUser = false;
            }else{
                collect.forgetChange=false;
                collect.registerChange=false;
                collect.loginChange=true;
                collect.companyUser = false;
            }
        }

        function agreement_boo(parameter) {  //协议勾选不勾选
            console.log("协议勾选不勾选");
            console.log(parameter);
            if(parameter === 1){
                collect.agreement = true;
            }else{
                collect.agreement = false;
            }
        }

        function protocol(){  //弹出协议框
            console.log("弹出协议框");
            collect.agreement_pop = true;
        }

        function protocol_confirm(){  //同意协议
            console.log("同意协议");
            collect.agreement_pop = false;
            collect.agreement = true;
        }

        //检查手机号是否存在
        function userquery(userId) {
            let params=[{
                'userid':encodeURIComponent(userId),
            }];
            let str='queryinfo='+JSON.stringify(params);

            requestHandler.simpleRequest(constant.action.userquery,str).then(function(respone){

                if (respone.data=="null"){
                    collect.no_exist=true;
                    console.log('不存在');

                    
                }else {
                    collect.no_exist=false;
                    console.log('已存在');

                    
                }

                if(collect.registerChange && !collect.no_exist){
                    let alert=alertControl.show('',
                        '该手机号已注册，请直接登录',
                        [{
                            'title':'确定',
                            'action':function(){
                                alert.close();
                                collect.Change(3);
                            }
                        }]
                    );
                    
                }else if(collect.forgetChange&&collect.no_exist){
                    let alert=alertControl.show('',
                        '该手机号码尚未注册，请先完成账号注册',
                        [{
                            'title':'确定',
                            'action':function(){
                                alert.close();
                                collect.Change(2);
                            }
                        }]
                    );
                }else{
                    let params=[{
                        'smstype':0,
                        'userid':encodeURIComponent(userId),
                    }];
                    // let params='userid='+userName+'&pwd='+password;
                    let str='userinfo='+JSON.stringify(params);
                    requestHandler.simpleRequest(constant.action.getVerify_code,str).then(function(respone){
                        // alert('已发送到短信')
                        if(respone.data.code==200){
                            let alert=alertControl.show('',
                                '已发送到短信',
                                [{
                                    'title':'确定',
                                    'action':function(){
                                        alert.close();
                                    }
                                }]
                            );
                        // }else if(respone.data.code==416){
                        //     let alert=alertControl.show('',
                        //         '您的操作过于频繁，请稍后再试',
                        //         [{
                        //             'title':'确定',
                        //             'action':function(){
                        //                 alert.close();
                        //             }
                        //         }]
                        //     );
                        }else{
                            let alert=alertControl.show('',
                                '获取验证码失败，请稍后再试，或者联系服务商',
                                [{
                                    'title':'确定',
                                    'action':function(){
                                        alert.close();
                                    }
                                }]
                            );
                        }

                        
                    });
                }
            });
        }

        //点击获取验证码
        function checkPhone(data) {
            let phone=data;
            if (phone.length<=0){
                // alert('请输入手机号码');
                let alert=alertControl.show('',
                    '请输入手机号码',
                    [{
                        'title':'确定',
                        'action':function(){
                            alert.close();
                        }
                    }]
                );
            }else {
                if(!(/^1[3456789]\d{9}$/.test(phone))){
                    // alert("手机号码有误");
                    let alert=alertControl.show('',
                        '手机号码有误',
                        [{
                            'title':'确定',
                            'action':function(){
                                alert.close();
                            }
                        }]
                    );
                    return false;
                }else {
                    userquery(data);

                }
            }
        }

        function registerFocus(bool) {

        }

        //申请企业用户
        function changeCompanyUser(){
            collect.forgetChange=false;
            collect.registerChange=false;
            collect.loginChange=false;
            collect.companyUser = true;
            console.log('kkkk');
        }

        //申请
        function application(){
            console.log(applicationInfo.userid);
            let params = [{
                'userid': encodeURIComponent(applicationInfo.userid),
                'companyid': encodeURIComponent(applicationInfo.companyid),
                'usermsg': encodeURIComponent(applicationInfo.usermsg),
            }];
            console.log('传的参数',params);
            let str='companyuserregister='+JSON.stringify(params);
            requestHandler.simpleRequest(constant.action.companyuserregister,str).then(
                function(responce){
                    console.log(responce);
                    if(responce.data[0].result==1){
                        console.log('成功申请，等待审批');

                        let alert=alertControl.show('',
                            '成功申请'+responce.data[0].msg + ',等待审批',
                            [{
                                'title':'确定',
                                'action':function(){
                                    alert.close();
                                }
                            }]
                        );
                    }else if(responce.data[0].result==0){
                        console.log('不能申请');
                        let alert=alertControl.show('',
                            responce.data[0].msg,
                            [{
                                'title':'确定',
                                'action':function(){
                                    alert.close();
                                }
                            }]
                        );
                    }
                },
                function(responce){
                    console.log(responce);
                }
            )
        }
    }

}